export default __webpack_public_path__ + "static/media/1_0044.17c5bc53.webp";